const spanishWords = {
    apoyo: true,
    amigo: true,
    armar: true,
    antes: true,
    ayuda: true,
    ahora: true,
    abrir: true,
    audaz: true,
    ajeno: true,
    aroma: true,
    andar: true,
    azada: true,
    agrio: true,
    actor: true,
    algun: true,
    axial: true,
    autor: true,
    ancho: true,
    avaro: true,
    ahito: true,
    ameno: true,
    astro: true,
    avion: true,
    aquel: true,
    agudo: true,
    aviso: true,
    arduo: true,
    abuso: true,
    apego: true,
    alzar: true,
    ansia: true,
    atrio: true,
    amado: true,
    alado: true,
    aunar: true,
    anexo: true,
    ayuno: true,
    atroz: true,
    ardid: true,
    atras: true,
    acero: true,
    aovar: true,
    abajo: true,
    arena: true,
    aereo: true,
    atajo: true,
    azote: true,
    atado: true,
    atril: true,
    ajado: true,
    ataud: true,
    asear: true,
    ardor: true,
    arder: true,
    araña: true,
    apodo: true,
    asilo: true,
    acoso: true,
    abono: true,
    aliar: true,
    añejo: true,
    acaso: true,
    aleta: true,
    aojar: true,
    axila: true,
    alero: true,
    apero: true,
    asado: true,
    aforo: true,
    aldea: true,
    apuro: true,
    argot: true,
    ambos: true,
    antro: true,
    ajuar: true,
    apear: true,
    aguja: true,
    acera: true,
    asomo: true,
    anden: true,
    ahogo: true,
    arcon: true,
    arado: true,
    arete: true,
    afear: true,
    airar: true,
    arada: true,
    anuro: true,
    amago: true,
    andas: true,
    amiga: true,
    arreo: true,
    arpon: true,
    atañe: true,
    abece: true,
    ardua: true,
    augur: true,
    albur: true,
    albor: true,
    aliño: true,
    alcor: true,
    añoso: true,
    autos: true,
    arpia: true,
    acedo: true,
    aupar: true,
    aleve: true,
    adios: true,
    arcen: true,
    atlas: true,
    alear: true,
    acato: true,
    arnes: true,
    añico: true,
    ajada: true,
    apaño: true,
    aloja: true,
    alias: true,
    abano: true,
    anana: true,
    ambon: true,
    ancon: true,
    añojo: true,
    anglo: true,
    arrea: true,
    aljez: true,
    alfar: true,
    andel: true,
    asere: true,
    ascua: true,
    adobo: true,
    avati: true,
    alaju: true,
    arria: true,
    adoso: true,
    arpas: true,
    alzan: true,
    apoca: true,
    alojo: true,
    asgas: true,
    avala: true,
    aleja: true,
    apana: true,
    adore: true,
    apoco: true,
    aunad: true,
    aliñe: true,
    atusa: true,
    alzas: true,
    avalo: true,
    alejo: true,
    acusa: true,
    atuso: true,
    alisa: true,
    acuso: true,
    arded: true,
    aliso: true,
    afean: true,
    alela: true,
    ahila: true,
    anota: true,
    adose: true,
    alelo: true,
    ahilo: true,
    anoto: true,
    afeas: true,
    avale: true,
    aleje: true,
    apane: true,
    atuse: true,
    acuse: true,
    alfan: true,
    alise: true,
    afama: true,
    alega: true,
    alele: true,
    arpen: true,
    añoja: true,
    ahile: true,
    anote: true,
    afamo: true,
    alfas: true,
    añosa: true,
    alego: true,
    alaba: true,
    aboca: true,
    añora: true,
    arpes: true,
    alabo: true,
    ajear: true,
    alcen: true,
    aboco: true,
    añoro: true,
    acata: true,
    arpar: true,
    alces: true,
    aduce: true,
    adula: true,
    afila: true,
    adulo: true,
    afame: true,
    afilo: true,
    aulos: true,
    afeen: true,
    añado: true,
    apiña: true,
    auges: true,
    abren: true,
    añore: true,
    abole: true,
    arpad: true,
    afees: true,
    abris: true,
    apiño: true,
    anime: true,
    abolo: true,
    aulas: true,
    aloje: true,
    adujo: true,
    auras: true,
    aisla: true,
    apaga: true,
    acate: true,
    alzad: true,
    aduje: true,
    adule: true,
    apega: true,
    afile: true,
    ajais: true,
    acude: true,
    aislo: true,
    aviva: true,
    alfen: true,
    apago: true,
    acuna: true,
    abria: true,
    araño: true,
    acudo: true,
    avivo: true,
    acuno: true,
    añadi: true,
    alfes: true,
    apiñe: true,
    apila: true,
    aboli: true,
    ajaba: true,
    afead: true,
    abrio: true,
    apilo: true,
    airan: true,
    azara: true,
    alude: true,
    apean: true,
    aisle: true,
    azaro: true,
    aludo: true,
    arañe: true,
    acudi: true,
    arais: true,
    asume: true,
    avive: true,
    acune: true,
    airas: true,
    apeas: true,
    asumo: true,
    añada: true,
    alfad: true,
    ajara: true,
    apile: true,
    ajare: true,
    araba: true,
    abran: true,
    andan: true,
    abola: true,
    atiza: true,
    argui: true,
    aerea: true,
    amolo: true,
    azare: true,
    aludi: true,
    atizo: true,
    abras: true,
    asada: true,
    amole: true,
    agita: true,
    asumi: true,
    ahuma: true,
    ajeis: true,
    acuda: true,
    aboga: true,
    agito: true,
    ahumo: true,
    aduci: true,
    abogo: true,
    avisa: true,
    arara: true,
    alian: true,
    arare: true,
    aveza: true,
    atice: true,
    avezo: true,
    agoro: true,
    atais: true,
    airen: true,
    agore: true,
    aluda: true,
    abrid: true,
    apeen: true,
    agite: true,
    ahume: true,
    areis: true,
    asuma: true,
    aires: true,
    avena: true,
    apees: true,
    avise: true,
    atada: true,
    ataba: true,
    aveno: true,
    agria: true,
    avece: true,
    aguda: true,
    atrae: true,
    anula: true,
    andes: true,
    anulo: true,
    ahita: true,
    ahoga: true,
    acnes: true,
    airad: true,
    atara: true,
    avene: true,
    apead: true,
    amola: true,
    asean: true,
    atare: true,
    ajena: true,
    amais: true,
    alada: true,
    alien: true,
    aseas: true,
    atina: true,
    alies: true,
    anule: true,
    atino: true,
    ateis: true,
    arman: true,
    aflui: true,
    ayudo: true,
    amaba: true,
    andad: true,
    apena: true,
    adoba: true,
    aulla: true,
    apeno: true,
    avara: true,
    armas: true,
    aullo: true,
    atine: true,
    ayude: true,
    amara: true,
    aliad: true,
    ateza: true,
    amasa: true,
    amare: true,
    atezo: true,
    apene: true,
    amaso: true,
    adobe: true,
    aulle: true,
    abusa: true,
    aseen: true,
    ameis: true,
    azuza: true,
    acaba: true,
    aceza: true,
    aunan: true,
    asees: true,
    asana: true,
    azuzo: true,
    acabo: true,
    acezo: true,
    ansio: true,
    anega: true,
    atece: true,
    amase: true,
    actua: true,
    anego: true,
    armen: true,
    aunas: true,
    acoge: true,
    arden: true,
    actuo: true,
    abuse: true,
    acojo: true,
    amada: true,
    asila: true,
    armes: true,
    ardes: true,
    anuda: true,
    asido: true,
    azuce: true,
    acabe: true,
    anudo: true,
    azota: true,
    acece: true,
    ansie: true,
    ataja: true,
    asead: true,
    ardia: true,
    azoto: true,
    aboya: true,
    actue: true,
    aboyo: true,
    ambas: true,
    asian: true,
    acogi: true,
    amena: true,
    albea: true,
    ardio: true,
    albeo: true,
    asile: true,
    altos: true,
    armad: true,
    asias: true,
    anexe: true,
    anude: true,
    apoda: true,
    anche: true,
    ahija: true,
    ataje: true,
    aloca: true,
    aboye: true,
    aunen: true,
    ahijo: true,
    aloco: true,
    albee: true,
    asira: true,
    adora: true,
    aunes: true,
    aliña: true,
    acoja: true,
    ardan: true,
    asire: true,
    adoro: true,
    ancha: true,
    amaga: true,
    apode: true,
    ardas: true,
    arpan: true,
    aneja: true,
    agrie: true,
    anexa: true,
    adosa: true,
    ahije: true,
    asgan: true,
    bajar: true,
    bella: true,
    bueno: true,
    breve: true,
    banal: true,
    basar: true,
    burdo: true,
    broma: true,
    brisa: true,
    bello: true,
    beber: true,
    bingo: true,
    burla: true,
    burro: true,
    barco: true,
    busca: true,
    bahia: true,
    baile: true,
    bravo: true,
    buena: true,
    banco: true,
    bruto: true,
    beodo: true,
    bogar: true,
    borde: true,
    bruja: true,
    barro: true,
    balon: true,
    besar: true,
    basto: true,
    banda: true,
    boton: true,
    bolso: true,
    botar: true,
    batir: true,
    bolsa: true,
    bulto: true,
    barra: true,
    bulla: true,
    berma: true,
    barca: true,
    brazo: true,
    bañar: true,
    barba: true,
    buque: true,
    brote: true,
    bando: true,
    bruma: true,
    bomba: true,
    bicho: true,
    brezo: true,
    buril: true,
    beato: true,
    brasa: true,
    bazar: true,
    blusa: true,
    bardo: true,
    bedel: true,
    brujo: true,
    busto: true,
    bufar: true,
    banca: true,
    boato: true,
    bordo: true,
    bufon: true,
    burgo: true,
    balsa: true,
    boina: true,
    broca: true,
    bajio: true,
    buche: true,
    breña: true,
    borla: true,
    bizco: true,
    bajon: true,
    betun: true,
    bamba: true,
    batel: true,
    boxeo: true,
    belen: true,
    bledo: true,
    bajel: true,
    bases: true,
    brega: true,
    bosta: true,
    bucle: true,
    bisel: true,
    botin: true,
    bache: true,
    bebes: true,
    bacin: true,
    bilis: true,
    bozal: true,
    bollo: true,
    bonos: true,
    biota: true,
    broza: true,
    balas: true,
    bucal: true,
    brete: true,
    baden: true,
    boyar: true,
    brota: true,
    bujia: true,
    borra: true,
    bolas: true,
    breva: true,
    bonus: true,
    beige: true,
    bombo: true,
    balda: true,
    binar: true,
    boira: true,
    bocon: true,
    batea: true,
    batin: true,
    bisar: true,
    bocal: true,
    bajos: true,
    boche: true,
    bureo: true,
    bongo: true,
    balde: true,
    bofia: true,
    bubon: true,
    berza: true,
    babel: true,
    belfo: true,
    bocel: true,
    baton: true,
    borna: true,
    buzar: true,
    braña: true,
    bemba: true,
    bizca: true,
    brego: true,
    borda: true,
    bañen: true,
    bañes: true,
    borre: true,
    bayos: true,
    baños: true,
    bañad: true,
    brava: true,
    bajan: true,
    bajas: true,
    beben: true,
    bruta: true,
    borro: true,
    burda: true,
    bebia: true,
    burra: true,
    bebio: true,
    baldo: true,
    barre: true,
    bogan: true,
    bajen: true,
    bisan: true,
    bogas: true,
    brios: true,
    bajes: true,
    bisas: true,
    beban: true,
    boyan: true,
    barri: true,
    bebas: true,
    birla: true,
    boyas: true,
    brama: true,
    birlo: true,
    bogue: true,
    bramo: true,
    bajad: true,
    basan: true,
    bulos: true,
    bebed: true,
    basas: true,
    birle: true,
    besan: true,
    brame: true,
    bisen: true,
    besas: true,
    buses: true,
    broto: true,
    bytes: true,
    bises: true,
    bulle: true,
    bacan: true,
    boyen: true,
    bullo: true,
    balin: true,
    boyes: true,
    buhos: true,
    bogad: true,
    bisad: true,
    bulli: true,
    babas: true,
    basen: true,
    boyad: true,
    besen: true,
    beses: true,
    bufan: true,
    bufas: true,
    burlo: true,
    basad: true,
    besad: true,
    burle: true,
    bajia: true,
    bufen: true,
    bufes: true,
    baila: true,
    bares: true,
    bailo: true,
    beata: true,
    bañan: true,
    bufad: true,
    belfa: true,
    bucea: true,
    bañas: true,
    buceo: true,
    beoda: true,
    bozon: true,
    bezon: true,
    bembo: true,
    busco: true,
    bucee: true,
    crear: true,
    comer: true,
    causa: true,
    carta: true,
    claro: true,
    coger: true,
    calma: true,
    cerca: true,
    campo: true,
    culpa: true,
    comun: true,
    capaz: true,
    cielo: true,
    copia: true,
    chico: true,
    ciego: true,
    clase: true,
    creer: true,
    color: true,
    curar: true,
    corte: true,
    culto: true,
    corto: true,
    clave: true,
    cauto: true,
    celos: true,
    casta: true,
    cinta: true,
    ciclo: true,
    calor: true,
    cerdo: true,
    cifra: true,
    carro: true,
    cargo: true,
    clima: true,
    clara: true,
    costa: true,
    calle: true,
    ceder: true,
    curso: true,
    cruel: true,
    chica: true,
    curva: true,
    citar: true,
    ceñir: true,
    chapa: true,
    cueva: true,
    cesar: true,
    canon: true,
    coche: true,
    cerro: true,
    carga: true,
    cagar: true,
    cabal: true,
    canal: true,
    caida: true,
    cutre: true,
    costo: true,
    cajon: true,
    chino: true,
    catar: true,
    carne: true,
    caber: true,
    circo: true,
    cisma: true,
    catre: true,
    callo: true,
    cavar: true,
    casar: true,
    coste: true,
    coser: true,
    coito: true,
    cuota: true,
    curvo: true,
    cirio: true,
    choza: true,
    cruce: true,
    cegar: true,
    cazar: true,
    crudo: true,
    cauce: true,
    censo: true,
    civil: true,
    cenit: true,
    coral: true,
    casto: true,
    canto: true,
    colar: true,
    calvo: true,
    cariz: true,
    cesta: true,
    clavo: true,
    cuero: true,
    chulo: true,
    canoa: true,
    celda: true,
    casco: true,
    calar: true,
    cable: true,
    cubil: true,
    colmo: true,
    cuate: true,
    cursi: true,
    cebar: true,
    cerco: true,
    caido: true,
    cabra: true,
    credo: true,
    cobro: true,
    cutis: true,
    crema: true,
    caqui: true,
    criba: true,
    cesto: true,
    cocer: true,
    caldo: true,
    cuita: true,
    chivo: true,
    cofre: true,
    calco: true,
    cacao: true,
    criar: true,
    cenar: true,
    cague: true,
    cejar: true,
    cirro: true,
    carpo: true,
    chola: true,
    curda: true,
    chuzo: true,
    calzo: true,
    cerne: true,
    calva: true,
    chale: true,
    cisco: true,
    capon: true,
    clava: true,
    cidro: true,
    cieno: true,
    corse: true,
    craso: true,
    carpa: true,
    canje: true,
    calmo: true,
    cinto: true,
    cojin: true,
    chile: true,
    cruza: true,
    corro: true,
    cacho: true,
    copla: true,
    comic: true,
    china: true,
    comba: true,
    cafre: true,
    chato: true,
    cupon: true,
    cuasi: true,
    calza: true,
    compa: true,
    coima: true,
    cerda: true,
    chavo: true,
    caliz: true,
    careo: true,
    caray: true,
    curia: true,
    crios: true,
    corvo: true,
    chava: true,
    copar: true,
    chepa: true,
    curro: true,
    cromo: true,
    curdo: true,
    chupa: true,
    corta: true,
    cagon: true,
    cisne: true,
    chamo: true,
    choto: true,
    cilla: true,
    cucar: true,
    carey: true,
    cuete: true,
    chiva: true,
    chala: true,
    casca: true,
    cacri: true,
    chozo: true,
    chito: true,
    coala: true,
    cuche: true,
    codal: true,
    clown: true,
    chiri: true,
    cumba: true,
    cavea: true,
    coine: true,
    cebon: true,
    coyan: true,
    confr: true,
    chira: true,
    corra: true,
    cojas: true,
    cubro: true,
    cenen: true,
    creas: true,
    cause: true,
    chafa: true,
    cieis: true,
    cebos: true,
    copen: true,
    cundi: true,
    cenes: true,
    cobre: true,
    copes: true,
    cagad: true,
    caten: true,
    cubri: true,
    cimba: true,
    coged: true,
    creia: true,
    ceben: true,
    carea: true,
    copio: true,
    cosen: true,
    cebes: true,
    cenad: true,
    creyo: true,
    crina: true,
    cunda: true,
    coses: true,
    crino: true,
    copad: true,
    coita: true,
    cenas: true,
    canes: true,
    canas: true,
    creen: true,
    cosia: true,
    cubra: true,
    capta: true,
    copie: true,
    caree: true,
    capto: true,
    catad: true,
    crees: true,
    cosio: true,
    cebad: true,
    crine: true,
    culea: true,
    coite: true,
    cazan: true,
    cuida: true,
    culeo: true,
    cuido: true,
    capte: true,
    cazas: true,
    clama: true,
    cread: true,
    cuaja: true,
    caben: true,
    clamo: true,
    citan: true,
    cimas: true,
    cosan: true,
    chora: true,
    culee: true,
    choro: true,
    citas: true,
    cosas: true,
    cuide: true,
    ciemo: true,
    creed: true,
    cabia: true,
    cipos: true,
    clame: true,
    cuaje: true,
    chore: true,
    cosed: true,
    cesan: true,
    cacen: true,
    cabre: true,
    chuta: true,
    curve: true,
    cesas: true,
    caces: true,
    chuto: true,
    colgo: true,
    caeis: true,
    cisca: true,
    citen: true,
    capos: true,
    canta: true,
    cojea: true,
    crian: true,
    ciñen: true,
    conto: true,
    caigo: true,
    caian: true,
    ceñis: true,
    cojeo: true,
    cites: true,
    conte: true,
    crias: true,
    chute: true,
    caias: true,
    calce: true,
    caras: true,
    cazad: true,
    calme: true,
    ceñia: true,
    cerre: true,
    cribo: true,
    campa: true,
    cante: true,
    cojee: true,
    curan: true,
    caera: true,
    cabed: true,
    citad: true,
    cesen: true,
    caere: true,
    calca: true,
    curas: true,
    clics: true,
    ceses: true,
    cubas: true,
    carda: true,
    cribe: true,
    cardo: true,
    cubos: true,
    campe: true,
    caiga: true,
    cuece: true,
    crien: true,
    colga: true,
    ciñan: true,
    coces: true,
    cabes: true,
    cuezo: true,
    cucos: true,
    cursa: true,
    comen: true,
    cries: true,
    ciñas: true,
    cocia: true,
    conta: true,
    cesad: true,
    cansa: true,
    cocas: true,
    comes: true,
    carde: true,
    cauta: true,
    culpo: true,
    canso: true,
    cocio: true,
    calla: true,
    comia: true,
    cocos: true,
    cerra: true,
    curte: true,
    chive: true,
    combo: true,
    cuajo: true,
    carpe: true,
    curra: true,
    curen: true,
    curto: true,
    curse: true,
    comio: true,
    criad: true,
    ceñid: true,
    cures: true,
    culpe: true,
    cucan: true,
    canse: true,
    ceden: true,
    crasa: true,
    cucas: true,
    combe: true,
    cifro: true,
    cerni: true,
    cedes: true,
    cacos: true,
    chalo: true,
    curti: true,
    cadas: true,
    cueza: true,
    carpi: true,
    curre: true,
    codea: true,
    cupos: true,
    cedia: true,
    codeo: true,
    coman: true,
    casos: true,
    censa: true,
    curad: true,
    cruda: true,
    crece: true,
    cedio: true,
    cafes: true,
    comas: true,
    cuque: true,
    cifre: true,
    cajas: true,
    curta: true,
    cuata: true,
    codee: true,
    coced: true,
    chata: true,
    cagan: true,
    cacha: true,
    cogen: true,
    cense: true,
    cuños: true,
    cagas: true,
    chafo: true,
    cates: true,
    creci: true,
    corre: true,
    colma: true,
    culta: true,
    cedan: true,
    comed: true,
    coges: true,
    cenan: true,
    ciado: true,
    ciais: true,
    cedas: true,
    copan: true,
    cogia: true,
    choca: true,
    checa: true,
    choco: true,
    checo: true,
    chula: true,
    copas: true,
    chafe: true,
    cogio: true,
    ciaba: true,
    catan: true,
    ciega: true,
    corri: true,
    colme: true,
    ceban: true,
    cabro: true,
    catas: true,
    cucad: true,
    chota: true,
    ceded: true,
    cebas: true,
    causo: true,
    cunde: true,
    chama: true,
    cruzo: true,
    cobra: true,
    cundo: true,
    ciara: true,
    calos: true,
    camas: true,
    cavos: true,
    ciare: true,
    cojan: true,
    cayos: true,
    crean: true,
    cubre: true,
    deseo: true,
    donde: true,
    decir: true,
    dulce: true,
    dejar: true,
    deber: true,
    dicha: true,
    dueño: true,
    dotar: true,
    debil: true,
    dolor: true,
    denso: true,
    dieta: true,
    donar: true,
    durar: true,
    dicho: true,
    danza: true,
    dudar: true,
    deuda: true,
    dosis: true,
    drama: true,
    dañar: true,
    docto: true,
    docil: true,
    duelo: true,
    digno: true,
    droga: true,
    dogma: true,
    doble: true,
    diosa: true,
    disco: true,
    dardo: true,
    ducha: true,
    desde: true,
    domar: true,
    doler: true,
    dueto: true,
    dorso: true,
    demas: true,
    ducho: true,
    dique: true,
    dandi: true,
    dador: true,
    debut: true,
    dorar: true,
    duela: true,
    datil: true,
    darse: true,
    ducto: true,
    diana: true,
    dueña: true,
    dable: true,
    divan: true,
    deudo: true,
    duplo: true,
    dombo: true,
    dundo: true,
    dison: true,
    dalle: true,
    depre: true,
    dunda: true,
    daras: true,
    dupla: true,
    dejan: true,
    dicen: true,
    daria: true,
    decis: true,
    dejas: true,
    duden: true,
    deben: true,
    dados: true,
    demos: true,
    dudes: true,
    dagas: true,
    densa: true,
    decia: true,
    daños: true,
    diere: true,
    debia: true,
    debes: true,
    diran: true,
    debio: true,
    dudad: true,
    disca: true,
    diras: true,
    danzo: true,
    diria: true,
    dejen: true,
    duche: true,
    digan: true,
    dejes: true,
    dedos: true,
    digas: true,
    dance: true,
    deban: true,
    doñea: true,
    doñeo: true,
    debas: true,
    dista: true,
    disto: true,
    dejad: true,
    decid: true,
    doñee: true,
    debed: true,
    dento: true,
    dente: true,
    dobla: true,
    doblo: true,
    donan: true,
    dañan: true,
    dañas: true,
    desoi: true,
    dicta: true,
    dicto: true,
    desea: true,
    doran: true,
    denta: true,
    doras: true,
    dormi: true,
    divos: true,
    dotan: true,
    donen: true,
    dicte: true,
    dañen: true,
    dotas: true,
    desee: true,
    dañes: true,
    duran: true,
    domas: true,
    donad: true,
    doren: true,
    dañad: true,
    dores: true,
    doman: true,
    dones: true,
    doten: true,
    dotes: true,
    doñas: true,
    dorad: true,
    digna: true,
    duren: true,
    dures: true,
    dotad: true,
    domen: true,
    dilui: true,
    dunas: true,
    durad: true,
    domes: true,
    duras: true,
    drena: true,
    dudan: true,
    dando: true,
    dreno: true,
    duros: true,
    damos: true,
    dudas: true,
    decae: true,
    draga: true,
    daban: true,
    domad: true,
    docta: true,
    drago: true,
    dabas: true,
    drene: true,
    dimos: true,
    diste: true,
    daran: true,
    decai: true,
    etapa: true,
    estar: true,
    error: true,
    echar: true,
    enojo: true,
    ebrio: true,
    etnia: true,
    errar: true,
    envio: true,
    enano: true,
    extra: true,
    ejote: true,
    espia: true,
    efebo: true,
    esmog: true,
    entre: true,
    esnob: true,
    enves: true,
    equis: true,
    email: true,
    estro: true,
    erebo: true,
    enema: true,
    eolio: true,
    elepe: true,
    emito: true,
    ebria: true,
    educa: true,
    educo: true,
    echan: true,
    envie: true,
    emiti: true,
    echas: true,
    emita: true,
    errad: true,
    elude: true,
    eludo: true,
    echen: true,
    enana: true,
    elige: true,
    eches: true,
    elijo: true,
    evade: true,
    eludi: true,
    evado: true,
    elegi: true,
    echad: true,
    eleva: true,
    elevo: true,
    evadi: true,
    eluda: true,
    expia: true,
    exime: true,
    expio: true,
    eximo: true,
    eleve: true,
    elija: true,
    evada: true,
    expie: true,
    eximi: true,
    eriza: true,
    erizo: true,
    evita: true,
    exima: true,
    erice: true,
    evito: true,
    evite: true,
    entra: true,
    entro: true,
    estan: true,
    edita: true,
    edito: true,
    estas: true,
    estoy: true,
    emana: true,
    emano: true,
    edite: true,
    exige: true,
    exijo: true,
    evoca: true,
    emane: true,
    ergui: true,
    evoco: true,
    esten: true,
    estes: true,
    exigi: true,
    eroga: true,
    erogo: true,
    estad: true,
    erras: true,
    exija: true,
    erais: true,
    envia: true,
    emite: true,
    feliz: true,
    final: true,
    forma: true,
    falta: true,
    frase: true,
    facil: true,
    friki: true,
    flujo: true,
    flaco: true,
    firme: true,
    futil: true,
    furor: true,
    fondo: true,
    fluir: true,
    fruto: true,
    falso: true,
    fijar: true,
    fauna: true,
    favor: true,
    fuera: true,
    firma: true,
    fuego: true,
    flojo: true,
    furia: true,
    faena: true,
    fallo: true,
    feroz: true,
    falaz: true,
    fosil: true,
    falla: true,
    fatal: true,
    fugaz: true,
    feria: true,
    fatuo: true,
    flora: true,
    fibra: true,
    fecha: true,
    finca: true,
    fruta: true,
    funda: true,
    falda: true,
    farsa: true,
    falto: true,
    farol: true,
    frito: true,
    fuero: true,
    fiera: true,
    fardo: true,
    flota: true,
    felon: true,
    fisco: true,
    freno: true,
    flete: true,
    ficha: true,
    flema: true,
    fusil: true,
    friso: true,
    feraz: true,
    fango: true,
    finta: true,
    freir: true,
    fobia: true,
    fiero: true,
    forro: true,
    fugar: true,
    farra: true,
    felpa: true,
    filon: true,
    fajar: true,
    fleco: true,
    focha: true,
    fumar: true,
    folio: true,
    fogon: true,
    flama: true,
    facha: true,
    fanal: true,
    filme: true,
    fuste: true,
    feudo: true,
    fasto: true,
    fusta: true,
    fonda: true,
    fosco: true,
    filia: true,
    finar: true,
    falua: true,
    finge: true,
    flato: true,
    forja: true,
    forum: true,
    figon: true,
    fosca: true,
    fosal: true,
    frote: true,
    fatum: true,
    fusis: true,
    farsi: true,
    fiemo: true,
    feuco: true,
    fleta: true,
    filos: true,
    forme: true,
    fuere: true,
    fines: true,
    frega: true,
    forjo: true,
    finos: true,
    fugad: true,
    forje: true,
    funja: true,
    filma: true,
    filmo: true,
    faeno: true,
    falsa: true,
    fisga: true,
    frota: true,
    froto: true,
    faene: true,
    fasta: true,
    floto: true,
    fiado: true,
    facas: true,
    fiais: true,
    foros: true,
    flaca: true,
    frien: true,
    floja: true,
    flote: true,
    freis: true,
    fajan: true,
    fiaba: true,
    fajas: true,
    fiaca: true,
    freia: true,
    finto: true,
    fiara: true,
    falos: true,
    fiare: true,
    ficho: true,
    forra: true,
    fisgo: true,
    famas: true,
    finte: true,
    frita: true,
    fieis: true,
    frioa: true,
    floro: true,
    freta: true,
    freto: true,
    frian: true,
    fiche: true,
    finjo: true,
    fundi: true,
    fajen: true,
    forre: true,
    frias: true,
    fajes: true,
    flore: true,
    frete: true,
    finan: true,
    fingi: true,
    faros: true,
    filio: true,
    finas: true,
    freid: true,
    fajad: true,
    fuman: true,
    fases: true,
    fumas: true,
    fundo: true,
    filie: true,
    finja: true,
    fluis: true,
    fulge: true,
    fluye: true,
    fuljo: true,
    fluyo: true,
    faces: true,
    fluia: true,
    fungi: true,
    funde: true,
    finen: true,
    frena: true,
    fulgi: true,
    fumen: true,
    fumes: true,
    fugan: true,
    frene: true,
    frego: true,
    fulja: true,
    fluya: true,
    fetos: true,
    finad: true,
    fugas: true,
    falte: true,
    fumad: true,
    fugue: true,
    formo: true,
    fluid: true,
    fijos: true,
    funge: true,
    funjo: true,
    freza: true,
    golpe: true,
    grupo: true,
    girar: true,
    globo: true,
    grito: true,
    gordo: true,
    ganar: true,
    grave: true,
    grato: true,
    gente: true,
    gozar: true,
    gusto: true,
    guapa: true,
    grado: true,
    guiar: true,
    guapo: true,
    gesto: true,
    ganas: true,
    genio: true,
    gasto: true,
    ganso: true,
    gruta: true,
    garbo: true,
    gesta: true,
    golfo: true,
    grano: true,
    gueto: true,
    gemir: true,
    gnomo: true,
    gorra: true,
    grasa: true,
    galan: true,
    guisa: true,
    ganga: true,
    guion: true,
    gorro: true,
    gramo: true,
    glosa: true,
    garra: true,
    gallo: true,
    grava: true,
    graso: true,
    guita: true,
    gafas: true,
    garzo: true,
    grumo: true,
    galon: true,
    gañir: true,
    galio: true,
    grajo: true,
    grelo: true,
    guiso: true,
    gafar: true,
    greña: true,
    guiri: true,
    gorda: true,
    garla: true,
    gozne: true,
    grifo: true,
    grima: true,
    gases: true,
    garua: true,
    guasa: true,
    grana: true,
    gacha: true,
    gaban: true,
    grada: true,
    grama: true,
    galas: true,
    golfa: true,
    gubia: true,
    grupa: true,
    greda: true,
    guata: true,
    guano: true,
    grapa: true,
    gocho: true,
    guija: true,
    gofre: true,
    gongo: true,
    grifa: true,
    guito: true,
    gorja: true,
    guila: true,
    guzgo: true,
    gravo: true,
    gozas: true,
    grogs: true,
    grita: true,
    gruas: true,
    garlo: true,
    gocen: true,
    grite: true,
    goces: true,
    garle: true,
    gruñe: true,
    ganan: true,
    gruño: true,
    gozad: true,
    grapo: true,
    gruñi: true,
    guian: true,
    gulas: true,
    guias: true,
    gimen: true,
    gemis: true,
    guifa: true,
    grape: true,
    gemia: true,
    gruña: true,
    ganen: true,
    gimio: true,
    ganes: true,
    gusta: true,
    gasas: true,
    guien: true,
    golea: true,
    goleo: true,
    guies: true,
    giman: true,
    ganad: true,
    guste: true,
    geles: true,
    gimas: true,
    gemas: true,
    graba: true,
    golee: true,
    grabo: true,
    guiad: true,
    gañis: true,
    gemid: true,
    gasta: true,
    grabe: true,
    giran: true,
    gañia: true,
    galla: true,
    giras: true,
    gaste: true,
    giros: true,
    gises: true,
    gansa: true,
    garza: true,
    galle: true,
    gloso: true,
    giren: true,
    goles: true,
    gires: true,
    glose: true,
    gongs: true,
    gañid: true,
    gotas: true,
    graja: true,
    gozos: true,
    girad: true,
    guais: true,
    guise: true,
    grata: true,
    guzga: true,
    graos: true,
    gozan: true,
    geste: true,
    hacer: true,
    hecho: true,
    hueco: true,
    habil: true,
    haber: true,
    honor: true,
    hogar: true,
    hasta: true,
    huevo: true,
    habla: true,
    hacia: true,
    huida: true,
    hobby: true,
    herir: true,
    hielo: true,
    horda: true,
    humor: true,
    heroe: true,
    harto: true,
    hilar: true,
    hueso: true,
    hurto: true,
    heces: true,
    hosco: true,
    hedor: true,
    haren: true,
    himno: true,
    helar: true,
    hebra: true,
    hondo: true,
    halar: true,
    halla: true,
    honra: true,
    hiato: true,
    hipar: true,
    hucha: true,
    hertz: true,
    horca: true,
    heder: true,
    hueva: true,
    hindu: true,
    huron: true,
    hongo: true,
    hacha: true,
    huero: true,
    honda: true,
    horma: true,
    hotel: true,
    horro: true,
    hades: true,
    humus: true,
    heñir: true,
    hacho: true,
    hinco: true,
    huesa: true,
    hunda: true,
    hecha: true,
    hiera: true,
    halen: true,
    hendi: true,
    hales: true,
    huela: true,
    herid: true,
    hervi: true,
    halad: true,
    hiela: true,
    helas: true,
    holga: true,
    hacen: true,
    hende: true,
    horra: true,
    hosca: true,
    hurga: true,
    hueca: true,
    hurgo: true,
    haran: true,
    hiele: true,
    haras: true,
    harba: true,
    haria: true,
    hemos: true,
    harbo: true,
    hagan: true,
    hagas: true,
    habia: true,
    helad: true,
    hados: true,
    halas: true,
    harbe: true,
    halos: true,
    habra: true,
    haced: true,
    habre: true,
    humea: true,
    humeo: true,
    hatos: true,
    hayas: true,
    haces: true,
    hazas: true,
    hayan: true,
    hilan: true,
    humee: true,
    hilas: true,
    henos: true,
    habed: true,
    hollo: true,
    holle: true,
    hiede: true,
    hilen: true,
    hedes: true,
    hiedo: true,
    harte: true,
    hiles: true,
    hedia: true,
    humos: true,
    husos: true,
    hiñen: true,
    heñis: true,
    honro: true,
    hedio: true,
    heñia: true,
    hablo: true,
    hinca: true,
    hilad: true,
    honre: true,
    holla: true,
    hojea: true,
    hallo: true,
    hurta: true,
    hojeo: true,
    hable: true,
    hieda: true,
    hunde: true,
    heris: true,
    hiere: true,
    hundo: true,
    hiero: true,
    hiñan: true,
    halle: true,
    halan: true,
    hojee: true,
    heria: true,
    hurte: true,
    hiñas: true,
    heded: true,
    hifen: true,
    hirio: true,
    hundi: true,
    huele: true,
    huelo: true,
    heñid: true,
    hampa: true,
    harta: true,
    holgo: true,
    ideal: true,
    icono: true,
    igual: true,
    iluso: true,
    ijada: true,
    ileso: true,
    idear: true,
    ideas: true,
    impar: true,
    indio: true,
    impio: true,
    istmo: true,
    ixtle: true,
    inane: true,
    izado: true,
    idota: true,
    irani: true,
    ilota: true,
    ibero: true,
    iones: true,
    insta: true,
    idead: true,
    islas: true,
    intui: true,
    itera: true,
    irrui: true,
    itero: true,
    itere: true,
    incoa: true,
    imbui: true,
    incoo: true,
    ilesa: true,
    ilusa: true,
    incoe: true,
    izais: true,
    imita: true,
    imito: true,
    izaba: true,
    imite: true,
    izara: true,
    izare: true,
    iceis: true,
    idean: true,
    iman: true,
    ibais: true,
    ireis: true,
    irian: true,
    irias: true,
    ideen: true,
    idees: true,
    jugar: true,
    jamas: true,
    joven: true,
    justo: true,
    juego: true,
    junto: true,
    jaula: true,
    jalar: true,
    jerga: true,
    jiron: true,
    junta: true,
    jaleo: true,
    judio: true,
    junco: true,
    justa: true,
    jabon: true,
    jadeo: true,
    joder: true,
    jarro: true,
    jarra: true,
    judas: true,
    jayan: true,
    jaque: true,
    juzga: true,
    jurar: true,
    jalon: true,
    judia: true,
    jamar: true,
    jamon: true,
    joyel: true,
    jiñar: true,
    jejen: true,
    joyon: true,
    jamad: true,
    juega: true,
    jugas: true,
    jiñan: true,
    jacas: true,
    jacos: true,
    jugue: true,
    jiñas: true,
    jatos: true,
    jipio: true,
    jefes: true,
    jiras: true,
    jiñen: true,
    jiñes: true,
    jugad: true,
    jubos: true,
    jiñad: true,
    junte: true,
    jalan: true,
    juran: true,
    jalas: true,
    jipia: true,
    juras: true,
    jipie: true,
    jalen: true,
    juren: true,
    jales: true,
    jures: true,
    jaman: true,
    jalad: true,
    jurad: true,
    jamen: true,
    james: true,
    juzgo: true,
    karma: true,
    koala: true,
    kefir: true,
    kepis: true,
    khaki: true,
    koine: true,
    kanes: true,
    kilos: true,
    largo: true,
    luego: true,
    lugar: true,
    lleno: true,
    libro: true,
    lento: true,
    libre: true,
    lindo: true,
    local: true,
    labor: true,
    lejos: true,
    listo: true,
    lecho: true,
    legal: true,
    logro: true,
    lucha: true,
    lider: true,
    linda: true,
    linea: true,
    llama: true,
    lista: true,
    letal: true,
    lucir: true,
    lapiz: true,
    legar: true,
    ligar: true,
    lobby: true,
    leche: true,
    lucro: true,
    lapso: true,
    lavar: true,
    letra: true,
    lycra: true,
    llave: true,
    llano: true,
    lanza: true,
    latir: true,
    laico: true,
    lerdo: true,
    labio: true,
    llaga: true,
    limar: true,
    limbo: true,
    labia: true,
    lloro: true,
    lamer: true,
    lente: true,
    laton: true,
    labil: true,
    lijar: true,
    licor: true,
    libar: true,
    ligue: true,
    ligon: true,
    linfa: true,
    liceo: true,
    lacar: true,
    losar: true,
    luces: true,
    llena: true,
    lacra: true,
    lance: true,
    lacio: true,
    larva: true,
    lonja: true,
    linde: true,
    lauro: true,
    lunar: true,
    leido: true,
    litis: true,
    liado: true,
    lidia: true,
    lioso: true,
    leida: true,
    lampa: true,
    laxar: true,
    lasca: true,
    lince: true,
    ludir: true,
    ladeo: true,
    lanar: true,
    licra: true,
    laude: true,
    lando: true,
    llapa: true,
    lardo: true,
    luxar: true,
    lumia: true,
    losas: true,
    logre: true,
    lisia: true,
    lisio: true,
    ludid: true,
    leian: true,
    liara: true,
    liare: true,
    leias: true,
    licuo: true,
    licue: true,
    lijad: true,
    lisie: true,
    lieis: true,
    leves: true,
    leera: true,
    leyes: true,
    lleva: true,
    leños: true,
    leere: true,
    llevo: true,
    liben: true,
    losen: true,
    libes: true,
    leais: true,
    llago: true,
    loses: true,
    lleve: true,
    lavan: true,
    ligan: true,
    lides: true,
    laxan: true,
    lavas: true,
    libad: true,
    licua: true,
    ligas: true,
    losad: true,
    laxas: true,
    lilas: true,
    labra: true,
    luxan: true,
    labro: true,
    libra: true,
    luxas: true,
    llora: true,
    liaza: true,
    labre: true,
    liras: true,
    laven: true,
    lidio: true,
    lisos: true,
    laxen: true,
    llamo: true,
    laxes: true,
    lites: true,
    llore: true,
    lacan: true,
    lidie: true,
    llene: true,
    luxen: true,
    llame: true,
    lenon: true,
    lacas: true,
    lavad: true,
    ligad: true,
    luxes: true,
    laxad: true,
    loado: true,
    loais: true,
    laque: true,
    liman: true,
    lapsa: true,
    larga: true,
    loaba: true,
    luxad: true,
    limas: true,
    lucen: true,
    lucis: true,
    loara: true,
    luzco: true,
    loare: true,
    lucia: true,
    lenta: true,
    lerda: true,
    llega: true,
    lados: true,
    loeis: true,
    llego: true,
    lucio: true,
    latex: true,
    lacad: true,
    limen: true,
    lajas: true,
    lamas: true,
    lamen: true,
    limes: true,
    lanas: true,
    laten: true,
    lames: true,
    ladra: true,
    latis: true,
    ladro: true,
    liosa: true,
    lamia: true,
    lapos: true,
    lares: true,
    luzca: true,
    latia: true,
    luden: true,
    lamio: true,
    ludis: true,
    lanzo: true,
    limad: true,
    latio: true,
    lasos: true,
    ladre: true,
    ludia: true,
    lijan: true,
    latos: true,
    lucho: true,
    lucid: true,
    lijas: true,
    ludio: true,
    laman: true,
    liste: true,
    latan: true,
    laves: true,
    laxos: true,
    latas: true,
    luche: true,
    ludan: true,
    liais: true,
    logra: true,
    lamed: true,
    ludas: true,
    latid: true,
    liaba: true,
    lijen: true,
    liban: true,
    losan: true,
    lelos: true,
    lijes: true,
    libas: true,
    leeis: true,
    miedo: true,
    mucho: true,
    mujer: true,
    mundo: true,
    mejor: true,
    mayor: true,
    mirar: true,
    matar: true,
    mania: true,
    mismo: true,
    morir: true,
    medio: true,
    motor: true,
    meter: true,
    medir: true,
    mover: true,
    madre: true,
    monte: true,
    mente: true,
    motin: true,
    movil: true,
    marco: true,
    marca: true,
    magia: true,
    moral: true,
    mando: true,
    mojar: true,
    mitad: true,
    metal: true,
    menos: true,
    media: true,
    menor: true,
    molde: true,
    mutuo: true,
    matiz: true,
    mitin: true,
    multa: true,
    manso: true,
    mueca: true,
    mimar: true,
    monje: true,
    malla: true,
    mixto: true,
    manar: true,
    mamar: true,
    morro: true,
    manta: true,
    musgo: true,
    minar: true,
    macho: true,
    moler: true,
    monto: true,
    mareo: true,
    mecha: true,
    monja: true,
    mudar: true,
    marea: true,
    magro: true,
    momia: true,
    morbo: true,
    merma: true,
    mitra: true,
    monta: true,
    magno: true,
    miope: true,
    morar: true,
    monda: true,
    maton: true,
    match: true,
    manto: true,
    mamon: true,
    mirlo: true,
    mirra: true,
    murar: true,
    meada: true,
    manda: true,
    mohin: true,
    mutar: true,
    modos: true,
    manir: true,
    mango: true,
    macis: true,
    muela: true,
    mosca: true,
    mural: true,
    mugre: true,
    mojon: true,
    molar: true,
    mudez: true,
    manga: true,
    meson: true,
    mugir: true,
    mutis: true,
    musas: true,
    majar: true,
    maria: true,
    medra: true,
    miron: true,
    metro: true,
    mande: true,
    meneo: true,
    mouse: true,
    mafia: true,
    mecer: true,
    magma: true,
    minga: true,
    medro: true,
    mocho: true,
    muñir: true,
    muslo: true,
    miton: true,
    micho: true,
    memez: true,
    macha: true,
    maula: true,
    millo: true,
    mermo: true,
    mamas: true,
    moron: true,
    momio: true,
    malva: true,
    mosco: true,
    metra: true,
    miaja: true,
    manea: true,
    mujol: true,
    mazar: true,
    melgo: true,
    marlo: true,
    machi: true,
    mamua: true,
    macia: true,
    marci: true,
    majas: true,
    mohos: true,
    manad: true,
    miden: true,
    minen: true,
    marra: true,
    mojos: true,
    maree: true,
    medis: true,
    marro: true,
    moles: true,
    mines: true,
    morid: true,
    marza: true,
    monas: true,
    marre: true,
    midio: true,
    mazos: true,
    mañas: true,
    minad: true,
    majen: true,
    monos: true,
    mutan: true,
    majes: true,
    mutas: true,
    midan: true,
    menea: true,
    mudan: true,
    medre: true,
    meten: true,
    midas: true,
    mudas: true,
    mecen: true,
    metes: true,
    mento: true,
    mueso: true,
    majad: true,
    meces: true,
    metia: true,
    menee: true,
    mecia: true,
    medid: true,
    metio: true,
    malea: true,
    matan: true,
    melga: true,
    mecio: true,
    maleo: true,
    matas: true,
    muten: true,
    memos: true,
    menti: true,
    moros: true,
    mutes: true,
    muden: true,
    muñen: true,
    muñis: true,
    malee: true,
    metan: true,
    mugen: true,
    mudes: true,
    mugis: true,
    mezan: true,
    muele: true,
    metas: true,
    monse: true,
    muñia: true,
    muelo: true,
    mezas: true,
    mutad: true,
    mugia: true,
    menta: true,
    molia: true,
    motes: true,
    maten: true,
    mugio: true,
    mudad: true,
    molio: true,
    motos: true,
    meted: true,
    menus: true,
    meced: true,
    mella: true,
    mozas: true,
    maman: true,
    mozos: true,
    moran: true,
    miran: true,
    mello: true,
    muñan: true,
    misma: true,
    mujan: true,
    moras: true,
    miras: true,
    misil: true,
    mixta: true,
    muñas: true,
    meros: true,
    matad: true,
    meses: true,
    mudos: true,
    masca: true,
    mujas: true,
    mesas: true,
    masco: true,
    melle: true,
    manis: true,
    mallo: true,
    mueve: true,
    muñid: true,
    moves: true,
    muevo: true,
    mugid: true,
    moled: true,
    movia: true,
    manio: true,
    mamen: true,
    malle: true,
    mojan: true,
    mondo: true,
    moren: true,
    miren: true,
    movio: true,
    mames: true,
    micos: true,
    mojas: true,
    mores: true,
    mires: true,
    mijos: true,
    monde: true,
    miles: true,
    mamad: true,
    merca: true,
    morad: true,
    mirad: true,
    mueva: true,
    mordi: true,
    mimos: true,
    mista: true,
    merco: true,
    mucha: true,
    mapas: true,
    manan: true,
    manid: true,
    mares: true,
    moris: true,
    mojen: true,
    muere: true,
    muero: true,
    mutua: true,
    miste: true,
    mojes: true,
    moved: true,
    moria: true,
    minan: true,
    murio: true,
    minas: true,
    mojad: true,
    mizos: true,
    manen: true,
    marce: true,
    morde: true,
    marzo: true,
    mases: true,
    manes: true,
    magna: true,
    magra: true,
    muera: true,
    majan: true,
    misto: true,
    mates: true,
    nuevo: true,
    nivel: true,
    norma: true,
    nunca: true,
    nacer: true,
    noche: true,
    niños: true,
    negro: true,
    notar: true,
    noble: true,
    nueva: true,
    nicho: true,
    negar: true,
    necio: true,
    norte: true,
    nieve: true,
    novio: true,
    ninfa: true,
    navio: true,
    niñez: true,
    nuera: true,
    nimio: true,
    nadar: true,
    novel: true,
    nariz: true,
    nylon: true,
    nimbo: true,
    naipe: true,
    nevar: true,
    natal: true,
    numen: true,
    niveo: true,
    naval: true,
    neura: true,
    nesga: true,
    nipon: true,
    napia: true,
    nidal: true,
    nadie: true,
    nauta: true,
    nenes: true,
    nublo: true,
    nones: true,
    norio: true,
    negus: true,
    nilon: true,
    nanay: true,
    nanai: true,
    noten: true,
    nuble: true,
    novia: true,
    notes: true,
    nubla: true,
    netos: true,
    notad: true,
    nexos: true,
    nidos: true,
    nodos: true,
    norme: true,
    notas: true,
    nubes: true,
    nucas: true,
    niega: true,
    negas: true,
    niego: true,
    normo: true,
    negue: true,
    nacen: true,
    naces: true,
    nazco: true,
    nacia: true,
    nacio: true,
    negad: true,
    nadga: true,
    nazca: true,
    narra: true,
    narro: true,
    nadas: true,
    naced: true,
    nanas: true,
    notan: true,
    narre: true,
    necia: true,
    negra: true,
    naves: true,
    nivea: true,
    orden: true,
    otoño: true,
    ojala: true,
    oveja: true,
    osado: true,
    optar: true,
    ocaso: true,
    obvio: true,
    oasis: true,
    obrar: true,
    obeso: true,
    omiso: true,
    ojota: true,
    ojear: true,
    ozono: true,
    opaco: true,
    ojera: true,
    otear: true,
    obice: true,
    odiar: true,
    oeste: true,
    otero: true,
    oxear: true,
    orate: true,
    okupa: true,
    ocupa: true,
    oreja: true,
    oidor: true,
    orgia: true,
    ornar: true,
    orina: true,
    orlar: true,
    orujo: true,
    ovino: true,
    opimo: true,
    obras: true,
    oliva: true,
    obesa: true,
    ojete: true,
    orear: true,
    oblea: true,
    oirse: true,
    osera: true,
    opina: true,
    oible: true,
    osear: true,
    oidio: true,
    olote: true,
    ozona: true,
    ooide: true,
    oxeas: true,
    opten: true,
    olera: true,
    optes: true,
    olere: true,
    opone: true,
    orlan: true,
    olais: true,
    orlas: true,
    optad: true,
    opuso: true,
    opuse: true,
    oxeen: true,
    obsto: true,
    obvia: true,
    obsta: true,
    oxees: true,
    obste: true,
    omisa: true,
    obvie: true,
    orlen: true,
    oxead: true,
    opaca: true,
    opima: true,
    orles: true,
    ornan: true,
    omina: true,
    opero: true,
    omino: true,
    ornas: true,
    osada: true,
    orlad: true,
    opere: true,
    omine: true,
    ovina: true,
    opino: true,
    osean: true,
    oseas: true,
    opine: true,
    ornen: true,
    ornes: true,
    ocupo: true,
    orado: true,
    orais: true,
    ocupe: true,
    ornad: true,
    obran: true,
    oraba: true,
    ovado: true,
    oseen: true,
    ovais: true,
    osees: true,
    ovaba: true,
    orara: true,
    orare: true,
    odian: true,
    osead: true,
    odias: true,
    ocios: true,
    oreis: true,
    ovara: true,
    ocres: true,
    ovare: true,
    obren: true,
    oveis: true,
    odios: true,
    obres: true,
    odres: true,
    oimos: true,
    orino: true,
    oiais: true,
    ogros: true,
    odien: true,
    obrad: true,
    odies: true,
    oiste: true,
    ollas: true,
    oiran: true,
    orine: true,
    oiras: true,
    otaku: true,
    onces: true,
    oiria: true,
    ondas: true,
    odiad: true,
    optan: true,
    oigan: true,
    optas: true,
    ocote: true,
    oclui: true,
    oigas: true,
    oyere: true,
    olido: true,
    oleis: true,
    olian: true,
    olias: true,
    oxean: true,
    poder: true,
    perro: true,
    pedir: true,
    poner: true,
    parte: true,
    papel: true,
    punto: true,
    pasar: true,
    pluma: true,
    pobre: true,
    parar: true,
    pagar: true,
    parco: true,
    plano: true,
    pieza: true,
    pausa: true,
    pegar: true,
    punta: true,
    pasto: true,
    padre: true,
    playa: true,
    pesar: true,
    pelea: true,
    pisar: true,
    pista: true,
    pulso: true,
    prado: true,
    pacto: true,
    pilar: true,
    pompa: true,
    paseo: true,
    parca: true,
    pleno: true,
    pared: true,
    pavor: true,
    poeta: true,
    pauta: true,
    pulir: true,
    parra: true,
    presa: true,
    prisa: true,
    plazo: true,
    poema: true,
    picar: true,
    plato: true,
    plaza: true,
    porte: true,
    pugna: true,
    probo: true,
    peste: true,
    polvo: true,
    pasta: true,
    plaga: true,
    pudor: true,
    parir: true,
    patio: true,
    pasmo: true,
    prosa: true,
    pillo: true,
    panel: true,
    perla: true,
    pinta: true,
    pecho: true,
    preso: true,
    plata: true,
    prole: true,
    persa: true,
    pañal: true,
    peaje: true,
    perra: true,
    placa: true,
    porno: true,
    porra: true,
    primo: true,
    penar: true,
    pollo: true,
    pardo: true,
    podar: true,
    plebe: true,
    pizca: true,
    pecar: true,
    pesca: true,
    palma: true,
    prior: true,
    panza: true,
    piano: true,
    potro: true,
    pacer: true,
    pelar: true,
    piara: true,
    pasma: true,
    punir: true,
    pitar: true,
    peine: true,
    puzle: true,
    patan: true,
    plomo: true,
    piñon: true,
    pezon: true,
    picha: true,
    parne: true,
    purga: true,
    patin: true,
    papeo: true,
    profe: true,
    podio: true,
    pacha: true,
    prima: true,
    potar: true,
    peana: true,
    posar: true,
    parto: true,
    pulla: true,
    penal: true,
    poste: true,
    pifia: true,
    polla: true,
    puñal: true,
    parvo: true,
    ponto: true,
    pampa: true,
    puber: true,
    perol: true,
    penas: true,
    pugil: true,
    palmo: true,
    pujar: true,
    polar: true,
    pulpa: true,
    palco: true,
    paron: true,
    piola: true,
    pilon: true,
    panda: true,
    pelon: true,
    penco: true,
    potra: true,
    pingo: true,
    prora: true,
    parce: true,
    puyar: true,
    peñon: true,
    piton: true,
    pocho: true,
    pater: true,
    palto: true,
    pompi: true,
    paves: true,
    palca: true,
    paila: true,
    punia: true,
    plise: true,
    poblo: true,
    pulas: true,
    puyes: true,
    poble: true,
    plena: true,
    paren: true,
    pedia: true,
    punio: true,
    previ: true,
    pocha: true,
    pares: true,
    piare: true,
    penes: true,
    pidio: true,
    pulse: true,
    pegan: true,
    pulid: true,
    puros: true,
    puyad: true,
    priva: true,
    pican: true,
    privo: true,
    pegas: true,
    pieis: true,
    parid: true,
    puyas: true,
    punan: true,
    puños: true,
    pasen: true,
    parad: true,
    peras: true,
    punas: true,
    pidan: true,
    pases: true,
    prive: true,
    pocos: true,
    pegue: true,
    pidas: true,
    pilan: true,
    pique: true,
    pobla: true,
    prava: true,
    ponen: true,
    placo: true,
    pilas: true,
    punid: true,
    plego: true,
    pasad: true,
    pasea: true,
    pones: true,
    pongo: true,
    pedid: true,
    ponia: true,
    penan: true,
    pravo: true,
    pasee: true,
    pagan: true,
    pegad: true,
    pagas: true,
    pilen: true,
    porta: true,
    proas: true,
    picad: true,
    porto: true,
    peros: true,
    piles: true,
    posee: true,
    ponga: true,
    poseo: true,
    plega: true,
    peleo: true,
    pague: true,
    prime: true,
    penen: true,
    pisan: true,
    pesan: true,
    pilad: true,
    profa: true,
    palio: true,
    posei: true,
    pisas: true,
    palie: true,
    poned: true,
    pesas: true,
    pelee: true,
    parda: true,
    plañe: true,
    palme: true,
    penad: true,
    pifio: true,
    pesos: true,
    palpa: true,
    pecan: true,
    posea: true,
    palpo: true,
    pasme: true,
    pacta: true,
    plañi: true,
    pecas: true,
    pelan: true,
    papea: true,
    petos: true,
    pagad: true,
    pifie: true,
    pelas: true,
    peces: true,
    pisen: true,
    pesco: true,
    parti: true,
    pesen: true,
    palpe: true,
    pacen: true,
    pudre: true,
    pudro: true,
    peses: true,
    peque: true,
    picas: true,
    pacte: true,
    paces: true,
    pazco: true,
    palia: true,
    papee: true,
    pacia: true,
    picos: true,
    pinto: true,
    parta: true,
    pacio: true,
    pisad: true,
    probe: true,
    pesad: true,
    pelen: true,
    pugno: true,
    pijos: true,
    pinte: true,
    puede: true,
    peles: true,
    podes: true,
    puedo: true,
    pudra: true,
    pilla: true,
    podia: true,
    palea: true,
    pazca: true,
    paleo: true,
    pecad: true,
    perdi: true,
    pugne: true,
    pelad: true,
    podra: true,
    pulen: true,
    puyan: true,
    pille: true,
    pulis: true,
    podre: true,
    palee: true,
    paced: true,
    paris: true,
    pises: true,
    proba: true,
    pipis: true,
    paran: true,
    pisos: true,
    pulia: true,
    posta: true,
    pueda: true,
    paria: true,
    place: true,
    paras: true,
    pitos: true,
    pulio: true,
    piñas: true,
    peina: true,
    pario: true,
    peino: true,
    piado: true,
    plisa: true,
    piais: true,
    pliso: true,
    punen: true,
    perde: true,
    preve: true,
    punis: true,
    pasan: true,
    placi: true,
    poded: true,
    plana: true,
    piaba: true,
    pulan: true,
    piden: true,
    puyen: true,
    pelos: true,
    pasas: true,
    pedis: true,
    pulsa: true,
    queja: true,
    quedo: true,
    quiza: true,
    quema: true,
    quita: true,
    quien: true,
    queda: true,
    quepi: true,
    quiui: true,
    queme: true,
    quede: true,
    quepo: true,
    quito: true,
    quite: true,
    quiso: true,
    quepa: true,
    quise: true,
    quere: true,
    quemo: true,
    regla: true,
    rumbo: true,
    razon: true,
    rueda: true,
    regar: true,
    robar: true,
    recto: true,
    resta: true,
    rubro: true,
    rigor: true,
    regir: true,
    ruido: true,
    rogar: true,
    ritmo: true,
    rabia: true,
    rival: true,
    raudo: true,
    rural: true,
    resto: true,
    rasgo: true,
    raspa: true,
    rezar: true,
    relax: true,
    rayar: true,
    ruina: true,
    raton: true,
    radio: true,
    rozar: true,
    regio: true,
    rumor: true,
    rango: true,
    reino: true,
    rocio: true,
    rampa: true,
    reves: true,
    rodar: true,
    rollo: true,
    ronda: true,
    reina: true,
    ruego: true,
    rubio: true,
    rugir: true,
    rodeo: true,
    reñir: true,
    raido: true,
    recio: true,
    rapto: true,
    robot: true,
    rehen: true,
    rotar: true,
    rubor: true,
    rizar: true,
    renta: true,
    roido: true,
    rimar: true,
    riego: true,
    ronco: true,
    rosca: true,
    redil: true,
    rasar: true,
    rasca: true,
    retal: true,
    rucio: true,
    rumia: true,
    racha: true,
    rojez: true,
    ropon: true,
    ralea: true,
    remar: true,
    rapaz: true,
    recua: true,
    rajar: true,
    rever: true,
    rocin: true,
    rumba: true,
    retar: true,
    recta: true,
    rapar: true,
    riada: true,
    reata: true,
    rorro: true,
    ramal: true,
    ruedo: true,
    rifar: true,
    reses: true,
    rengo: true,
    rabal: true,
    rular: true,
    rilar: true,
    renga: true,
    renco: true,
    rezno: true,
    razia: true,
    riata: true,
    rolla: true,
    rento: true,
    roque: true,
    roseo: true,
    rolde: true,
    rozno: true,
    round: true,
    rusco: true,
    redor: true,
    razar: true,
    rucho: true,
    rasea: true,
    ralle: true,
    ruega: true,
    raseo: true,
    rogas: true,
    rapen: true,
    reglo: true,
    riman: true,
    rapes: true,
    rimas: true,
    rasee: true,
    rogue: true,
    rinde: true,
    roben: true,
    rindo: true,
    roten: true,
    regle: true,
    robes: true,
    rigen: true,
    rotes: true,
    regis: true,
    rapad: true,
    rulan: true,
    rugen: true,
    regad: true,
    rulas: true,
    rugis: true,
    rendi: true,
    rondo: true,
    robad: true,
    rugia: true,
    rotad: true,
    rigio: true,
    rimen: true,
    rudos: true,
    rimes: true,
    rugio: true,
    ronde: true,
    roida: true,
    rulos: true,
    rinda: true,
    reine: true,
    rogad: true,
    rijan: true,
    rozan: true,
    rosea: true,
    rulen: true,
    rubia: true,
    rimad: true,
    rijas: true,
    rubra: true,
    rozas: true,
    rucha: true,
    rujan: true,
    rodea: true,
    rucia: true,
    rules: true,
    rujas: true,
    risca: true,
    reman: true,
    risco: true,
    remas: true,
    regid: true,
    rarea: true,
    rodee: true,
    rulad: true,
    rareo: true,
    rayan: true,
    rugid: true,
    rolle: true,
    rizan: true,
    rayas: true,
    rocen: true,
    repta: true,
    riela: true,
    relee: true,
    rizas: true,
    repto: true,
    raree: true,
    rielo: true,
    releo: true,
    roces: true,
    riñen: true,
    raijo: true,
    reñis: true,
    remen: true,
    remes: true,
    repte: true,
    riele: true,
    rapta: true,
    relei: true,
    rifan: true,
    reñia: true,
    rozad: true,
    rabio: true,
    rifas: true,
    reune: true,
    rayen: true,
    reuno: true,
    rilan: true,
    ricen: true,
    rayes: true,
    remad: true,
    rapte: true,
    relea: true,
    rilas: true,
    rices: true,
    rabie: true,
    reuni: true,
    raspo: true,
    riñan: true,
    rezan: true,
    rayad: true,
    riñas: true,
    reido: true,
    rezas: true,
    rizad: true,
    rifen: true,
    rumio: true,
    raspe: true,
    reian: true,
    rifes: true,
    raida: true,
    ronza: true,
    reuna: true,
    reias: true,
    ronzo: true,
    reñid: true,
    rilen: true,
    reble: true,
    rumie: true,
    rauda: true,
    riles: true,
    reira: true,
    ripio: true,
    rifad: true,
    ronce: true,
    rente: true,
    rabel: true,
    reire: true,
    rocia: true,
    recen: true,
    radia: true,
    reces: true,
    rompe: true,
    rigil: true,
    riais: true,
    rilad: true,
    reste: true,
    rompo: true,
    riere: true,
    rocie: true,
    radie: true,
    rapan: true,
    rezad: true,
    rompi: true,
    rapas: true,
    regia: true,
    riega: true,
    regas: true,
    ralla: true,
    roban: true,
    rallo: true,
    rotan: true,
    robas: true,
    rotas: true,
    rasco: true,
    rehui: true,
    rompa: true,
    renca: true,
    regue: true,
    salir: true,
    segun: true,
    subir: true,
    saber: true,
    sacar: true,
    snack: true,
    sabio: true,
    soñar: true,
    suave: true,
    señal: true,
    salud: true,
    spray: true,
    señor: true,
    senda: true,
    serio: true,
    sobre: true,
    suelo: true,
    sucio: true,
    sueño: true,
    sello: true,
    stock: true,
    sumar: true,
    signo: true,
    sutil: true,
    serie: true,
    sagaz: true,
    shock: true,
    staff: true,
    stand: true,
    silla: true,
    sitio: true,
    salon: true,
    socio: true,
    sanar: true,
    sabor: true,
    senil: true,
    soler: true,
    surco: true,
    susto: true,
    sudar: true,
    salto: true,
    santo: true,
    simil: true,
    super: true,
    secar: true,
    semen: true,
    selva: true,
    salvo: true,
    short: true,
    sesgo: true,
    sobra: true,
    sopor: true,
    sudor: true,
    saldo: true,
    savia: true,
    saeta: true,
    soplo: true,
    solaz: true,
    sorna: true,
    sonda: true,
    segar: true,
    secta: true,
    simio: true,
    silex: true,
    solar: true,
    sarta: true,
    sorbo: true,
    scout: true,
    sable: true,
    siega: true,
    sarao: true,
    sarna: true,
    sobar: true,
    senos: true,
    sazon: true,
    speed: true,
    saten: true,
    sacho: true,
    sosia: true,
    salva: true,
    sucia: true,
    sismo: true,
    señas: true,
    sacro: true,
    seudo: true,
    sumir: true,
    segur: true,
    saque: true,
    sigla: true,
    sisar: true,
    silba: true,
    sirga: true,
    sarro: true,
    sufra: true,
    solio: true,
    sajar: true,
    satan: true,
    sayon: true,
    siglo: true,
    solfa: true,
    sapos: true,
    salsa: true,
    siete: true,
    suplo: true,
    sigan: true,
    sumio: true,
    sitie: true,
    sudas: true,
    sorbe: true,
    sisan: true,
    seque: true,
    sento: true,
    sobad: true,
    silbe: true,
    sigas: true,
    sente: true,
    seran: true,
    sanad: true,
    sisas: true,
    seras: true,
    supli: true,
    sorbi: true,
    seais: true,
    suena: true,
    sonas: true,
    suele: true,
    signa: true,
    soles: true,
    supla: true,
    suden: true,
    solia: true,
    salen: true,
    seres: true,
    sondo: true,
    sudes: true,
    salis: true,
    sorba: true,
    sisen: true,
    sumid: true,
    sufre: true,
    secad: true,
    salgo: true,
    sufro: true,
    sises: true,
    signe: true,
    senta: true,
    suben: true,
    salia: true,
    subis: true,
    sonde: true,
    salio: true,
    sudad: true,
    subia: true,
    sufri: true,
    sesos: true,
    surjo: true,
    suene: true,
    sisad: true,
    setos: true,
    suela: true,
    sacia: true,
    subio: true,
    sexos: true,
    sacio: true,
    saben: true,
    suman: true,
    shows: true,
    surgi: true,
    soldo: true,
    salga: true,
    sabes: true,
    solde: true,
    sonad: true,
    sabia: true,
    sacie: true,
    soled: true,
    suban: true,
    sacra: true,
    subas: true,
    sopla: true,
    solto: true,
    surja: true,
    solte: true,
    salve: true,
    salid: true,
    sacon: true,
    sabra: true,
    santa: true,
    sabre: true,
    sella: true,
    silos: true,
    sagas: true,
    simas: true,
    subid: true,
    sales: true,
    salas: true,
    sepan: true,
    sople: true,
    sirve: true,
    sumen: true,
    sirvo: true,
    sepas: true,
    sumes: true,
    sanea: true,
    selle: true,
    salda: true,
    saneo: true,
    solda: true,
    situa: true,
    situo: true,
    sacan: true,
    servi: true,
    sacas: true,
    sabed: true,
    sumad: true,
    sanee: true,
    solta: true,
    salde: true,
    situe: true,
    surca: true,
    seria: true,
    sesga: true,
    sirva: true,
    sumas: true,
    sanos: true,
    sajan: true,
    sedar: true,
    sajas: true,
    simia: true,
    salan: true,
    salar: true,
    sibil: true,
    soban: true,
    socia: true,
    sañas: true,
    sebos: true,
    sanan: true,
    secas: true,
    sacad: true,
    sobas: true,
    secos: true,
    senti: true,
    sajen: true,
    sajes: true,
    sigue: true,
    sobro: true,
    sedes: true,
    sajad: true,
    soben: true,
    secan: true,
    sumis: true,
    segui: true,
    sitia: true,
    sanen: true,
    sobes: true,
    salad: true,
    surge: true,
    somos: true,
    silbo: true,
    sanes: true,
    sumia: true,
    suple: true,
    sudan: true,
    tener: true,
    tocar: true,
    tomar: true,
    tenaz: true,
    tarea: true,
    tanto: true,
    tarde: true,
    traer: true,
    total: true,
    temor: true,
    texto: true,
    tonto: true,
    turno: true,
    tejer: true,
    tapar: true,
    tenue: true,
    trama: true,
    trato: true,
    topar: true,
    tirar: true,
    tenia: true,
    tumba: true,
    torpe: true,
    tesis: true,
    trozo: true,
    temer: true,
    tapia: true,
    techo: true,
    terco: true,
    tosco: true,
    tedio: true,
    toque: true,
    tenso: true,
    tumor: true,
    truco: true,
    turba: true,
    teñir: true,
    timon: true,
    torre: true,
    tacto: true,
    telar: true,
    traje: true,
    trino: true,
    treta: true,
    traba: true,
    tañer: true,
    tribu: true,
    tutor: true,
    trazo: true,
    tenis: true,
    tabla: true,
    trago: true,
    torta: true,
    tieso: true,
    tasar: true,
    timar: true,
    temas: true,
    tropa: true,
    terso: true,
    tallo: true,
    trapo: true,
    trono: true,
    talud: true,
    tibia: true,
    talla: true,
    tapon: true,
    titan: true,
    talar: true,
    tinte: true,
    talle: true,
    torax: true,
    tramo: true,
    teson: true,
    tiron: true,
    torso: true,
    tifon: true,
    tonel: true,
    trola: true,
    tocon: true,
    tocho: true,
    tardo: true,
    trigo: true,
    tacon: true,
    trova: true,
    talon: true,
    tarja: true,
    tanda: true,
    totem: true,
    tenca: true,
    tunel: true,
    tapiz: true,
    tempo: true,
    traza: true,
    tenor: true,
    tacha: true,
    tarro: true,
    tunda: true,
    toldo: true,
    testa: true,
    tajar: true,
    tetas: true,
    trote: true,
    tumbo: true,
    tacho: true,
    tropo: true,
    torvo: true,
    tarta: true,
    tripa: true,
    tambo: true,
    traga: true,
    terna: true,
    tizne: true,
    tasca: true,
    tiara: true,
    terno: true,
    tibio: true,
    tebeo: true,
    trabe: true,
    tilde: true,
    tisis: true,
    turca: true,
    telon: true,
    troje: true,
    tordo: true,
    taita: true,
    trusa: true,
    taxon: true,
    tique: true,
    trena: true,
    tabes: true,
    tunco: true,
    tilin: true,
    tiros: true,
    toril: true,
    tizon: true,
    toche: true,
    tupir: true,
    tarma: true,
    tenta: true,
    toreo: true,
    tupan: true,
    tajos: true,
    temen: true,
    tales: true,
    tupas: true,
    troco: true,
    tasan: true,
    tejed: true,
    temes: true,
    timan: true,
    tasas: true,
    toree: true,
    temia: true,
    timas: true,
    tanta: true,
    trina: true,
    tarda: true,
    temio: true,
    tañen: true,
    tupid: true,
    tebea: true,
    tañes: true,
    tesen: true,
    torci: true,
    treme: true,
    trona: true,
    tremo: true,
    tañia: true,
    trios: true,
    teses: true,
    toman: true,
    trine: true,
    traed: true,
    teman: true,
    tules: true,
    tomas: true,
    tulle: true,
    tensa: true,
    tullo: true,
    tasen: true,
    tajan: true,
    turna: true,
    timen: true,
    tremi: true,
    tupes: true,
    tases: true,
    troca: true,
    tajas: true,
    terca: true,
    times: true,
    tesad: true,
    tersa: true,
    tañan: true,
    tulli: true,
    turne: true,
    tutes: true,
    temed: true,
    talan: true,
    tañas: true,
    tiesa: true,
    trema: true,
    tasad: true,
    techa: true,
    trata: true,
    timad: true,
    talas: true,
    torce: true,
    toros: true,
    tomen: true,
    tomes: true,
    tulla: true,
    tocha: true,
    tajen: true,
    tañed: true,
    teche: true,
    trate: true,
    tonta: true,
    tajes: true,
    torda: true,
    tendi: true,
    torva: true,
    tomad: true,
    tosca: true,
    tache: true,
    talen: true,
    triza: true,
    tibie: true,
    tajad: true,
    trizo: true,
    turbo: true,
    timba: true,
    trice: true,
    turbe: true,
    talad: true,
    trovo: true,
    tapan: true,
    tapas: true,
    tende: true,
    tiran: true,
    trove: true,
    tunca: true,
    tumbe: true,
    tiras: true,
    tapen: true,
    tanga: true,
    tango: true,
    tapes: true,
    tinta: true,
    tiene: true,
    tiren: true,
    tenes: true,
    tinto: true,
    tengo: true,
    tires: true,
    tesar: true,
    tejen: true,
    tauca: true,
    tapad: true,
    tense: true,
    tejes: true,
    tento: true,
    teste: true,
    tejia: true,
    tente: true,
    tirad: true,
    tupen: true,
    torna: true,
    tupis: true,
    tapio: true,
    tejio: true,
    torno: true,
    trota: true,
    tupia: true,
    troto: true,
    tenga: true,
    traen: true,
    tapie: true,
    tupio: true,
    torne: true,
    traes: true,
    tejan: true,
    trabo: true,
    traia: true,
    tejas: true,
    trone: true,
    tesan: true,
    tabus: true,
    tened: true,
    trace: true,
    trajo: true,
    torea: true,
    tesas: true,
    union: true,
    ufano: true,
    usted: true,
    urdir: true,
    usado: true,
    usual: true,
    unido: true,
    untar: true,
    ujier: true,
    urgir: true,
    usura: true,
    ultra: true,
    ungir: true,
    uncir: true,
    ucase: true,
    urubu: true,
    urdid: true,
    ulula: true,
    ululo: true,
    usais: true,
    ubica: true,
    ulule: true,
    ubico: true,
    usaba: true,
    upado: true,
    usara: true,
    ubres: true,
    upais: true,
    usare: true,
    upaba: true,
    useis: true,
    upara: true,
    untos: true,
    upare: true,
    urbes: true,
    urnas: true,
    upeis: true,
    uncen: true,
    uncis: true,
    uncia: true,
    ufana: true,
    uncio: true,
    usada: true,
    unzan: true,
    unzas: true,
    unian: true,
    urden: true,
    unias: true,
    urdis: true,
    urdia: true,
    uncid: true,
    unira: true,
    unire: true,
    urdio: true,
    unais: true,
    urdan: true,
    urdas: true,
    valor: true,
    vacio: true,
    viaje: true,
    volar: true,
    venta: true,
    viejo: true,
    vivir: true,
    vasto: true,
    veloz: true,
    visto: true,
    valla: true,
    verde: true,
    voraz: true,
    vicio: true,
    vital: true,
    veraz: true,
    velar: true,
    valle: true,
    vigor: true,
    vuelo: true,
    vista: true,
    venir: true,
    valer: true,
    vejez: true,
    venia: true,
    verbo: true,
    vapor: true,
    virus: true,
    vagar: true,
    vedar: true,
    vetar: true,
    vivaz: true,
    verso: true,
    votar: true,
    vacuo: true,
    vejar: true,
    valia: true,
    vario: true,
    viril: true,
    vagon: true,
    vulva: true,
    vulgo: true,
    varon: true,
    video: true,
    visar: true,
    vello: true,
    venda: true,
    vasco: true,
    vater: true,
    vivac: true,
    vamos: true,
    verse: true,
    villa: true,
    virar: true,
    verja: true,
    vaina: true,
    vigia: true,
    venal: true,
    verga: true,
    visor: true,
    vease: true,
    verme: true,
    vacar: true,
    velon: true,
    voace: true,
    vezar: true,
    valva: true,
    viñas: true,
    vence: true,
    valgo: true,
    venzo: true,
    venid: true,
    viven: true,
    vivar: true,
    vivis: true,
    volve: true,
    vende: true,
    vendo: true,
    valio: true,
    volca: true,
    venci: true,
    vivia: true,
    visen: true,
    vises: true,
    vacan: true,
    vivio: true,
    vejen: true,
    vendi: true,
    votos: true,
    vacas: true,
    voces: true,
    vejes: true,
    valga: true,
    venza: true,
    visad: true,
    vivan: true,
    vaque: true,
    vetan: true,
    vejad: true,
    vivas: true,
    vetas: true,
    valed: true,
    varea: true,
    vareo: true,
    vivid: true,
    versa: true,
    viran: true,
    varee: true,
    viras: true,
    vinea: true,
    vacia: true,
    vineo: true,
    veten: true,
    viaja: true,
    vacad: true,
    viajo: true,
    vetes: true,
    vinee: true,
    vacie: true,
    verti: true,
    viste: true,
    vetad: true,
    viren: true,
    vires: true,
    vesti: true,
    vento: true,
    vente: true,
    vuela: true,
    volas: true,
    virad: true,
    vemos: true,
    vallo: true,
    veian: true,
    verte: true,
    veias: true,
    vimos: true,
    vados: true,
    veran: true,
    vives: true,
    vagos: true,
    veras: true,
    vahos: true,
    votan: true,
    vacua: true,
    veria: true,
    vales: true,
    vuele: true,
    votas: true,
    veais: true,
    vezan: true,
    vivad: true,
    varia: true,
    vocea: true,
    vasca: true,
    vezas: true,
    voceo: true,
    vasta: true,
    viere: true,
    volad: true,
    venis: true,
    viene: true,
    vanos: true,
    vengo: true,
    varie: true,
    vocee: true,
    voten: true,
    viola: true,
    votes: true,
    volvi: true,
    violo: true,
    vecen: true,
    volco: true,
    vieja: true,
    veces: true,
    visan: true,
    viole: true,
    votad: true,
    venga: true,
    visas: true,
    vayan: true,
    vejan: true,
    vezad: true,
    vayas: true,
    valen: true,
    vejas: true,
    water: true,
    wafle: true,
    wiski: true,
    yerno: true,
    yacer: true,
    yerro: true,
    yermo: true,
    yelmo: true,
    yerba: true,
    yogur: true,
    yerto: true,
    yunta: true,
    yegua: true,
    yihad: true,
    yesca: true,
    yerna: true,
    yersi: true,
    yoqui: true,
    yocas: true,
    yerma: true,
    yerta: true,
    yacen: true,
    yaces: true,
    yacia: true,
    yacio: true,
    yanta: true,
    yanto: true,
    yates: true,
    yayos: true,
    yemas: true,
    yante: true,
    yucas: true,
    yutes: true,
    yaced: true,
    yendo: true,
    zorro: true,
    zurdo: true,
    zafio: true,
    zanja: true,
    zafar: true,
    zaino: true,
    zueco: true,
    zarza: true,
    zurra: true,
    zonzo: true,
    zagal: true,
    zambo: true,
    zafra: true,
    zanco: true,
    zuñir: true,
    zorra: true,
    zarpa: true,
    zurda: true,
    zumba: true,
    zaque: true,
    zarco: true,
    zoclo: true,
    zanca: true,
    zureo: true,
    zarpe: true,
    zaina: true,
    zamba: true,
    zarca: true,
    zurce: true,
    zurzo: true,
    zafan: true,
    zampa: true,
    zampo: true,
    zafas: true,
    zurci: true,
    zampe: true,
    zurza: true,
    zafen: true,
    zumbo: true,
    zafes: true,
    zagas: true,
    zumbe: true,
    zanjo: true,
    zafad: true,
    zares: true,
    zedas: true,
    zetas: true,
    zanje: true,
    zonas: true,
    zotes: true,
    zuros: true,
    zuñen: true,
    zuñis: true,
    zuñia: true,
    zuñan: true,
    zuñas: true,
    zuñid: true,
    zarpo: true
};
export const validSpanishWords = Object.keys(spanishWords);
